export const key = key => ({
  type: 'USER_KEY',
  key
})

export const balance = balance => ({
  type: 'USER_BALANCE',
  balance
})